import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const loaderStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  flexDirection: "column",
  fontFamily: "Arial, sans-serif",
  background: "#fff",
};

const spinnerStyle = {
  width: "48px",
  height: "48px",
  border: "4px solid #FF63B5",
  borderTopColor: "transparent",
  borderRadius: "50%",
  animation: "spin 0.8s linear infinite",
  marginBottom: "16px",
};

function FacebookCallback() {
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleFacebookCallback = async () => {
      try {
        const code = searchParams.get("code");
        const state = searchParams.get("state");

        if (!code) {
          document.open();
          document.write(`
            <html>
              <body style="font-family: Arial; text-align: center; padding: 40px;">
                <h2>No authorization code found.</h2>
              </body>
            </html>
          `);
          document.close();

          setLoading(false);
          return;
        }

        const baseURL = process.env.REACT_APP_API_URL;

        const params = new URLSearchParams({
          code,
        });

        if (state) {
          params.append("state", state);
        }

        const apiURL = `${baseURL}/webservice/api/v1/advertiser/streams/facebook/callback?${params.toString()}`;

        console.log("Facebook callback API:", apiURL);

        const response = await fetch(apiURL, {
          method: "GET",
          credentials: "include",
        });

        const htmlResponse = await response.text();

        console.log("Facebook callback HTML received:", htmlResponse);

        document.open();
        document.write(htmlResponse);
        document.close();
      } catch (error) {
        console.error("Facebook callback error:", error);

        document.open();
        document.write(`
          <html>
            <body style="font-family: Arial; text-align: center; padding: 40px;">
              <h2>Request Failed</h2>
              <p>${error.message}</p>
            </body>
          </html>
        `);
        document.close();
      } finally {
        setLoading(false);
      }
    };

    handleFacebookCallback();
  }, [searchParams]);

  if (loading) {
    return (
      <>
        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
          `}
        </style>

        <div style={loaderStyle}>
          <div style={spinnerStyle} />

          <p style={{ color: "#555", fontSize: "16px" }}>
            Connecting your Facebook account...
          </p>
        </div>
      </>
    );
  }

  return null;
}

export default FacebookCallback;